import { services } from '../constants/services';
import { usePrivacyConsentStore } from './usePrivacyConsentStore';
const NECESSARY_SERVICE_IDS = new Set(services.filter((service) => service.category === 'necessary').map((service) => service.id));
const isServiceGranted = (id, consents) => NECESSARY_SERVICE_IDS.has(id) || consents[id] === true;
const toArray = (service) => (Array.isArray(service) ? service : [service]);
export const usePrivacyConsent = (service) => {
    const consents = usePrivacyConsentStore((state) => state.consents);
    return toArray(service).every((id) => isServiceGranted(id, consents));
};
export const useFirstDeniedConsent = (service) => {
    const consents = usePrivacyConsentStore((state) => state.consents);
    return toArray(service).find((id) => !isServiceGranted(id, consents));
};
